import { Component } from '@theme/component';

/** A product-scoped, progressively enhanced three-colour preference picker. */
class HoppipollaColourMulti extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#enhance();
    this.syncColours();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#enhance();
    this.syncColours();
  }

  #enhance() {
    const basic = this.querySelector('[data-colour-basic]');
    const options = this.querySelector('[data-colour-options]');
    const property = this.querySelector('[data-colour-property]');
    if (!basic || !options || !(property instanceof HTMLInputElement)) return;
    const selects = [...basic.querySelectorAll('select')];
    const previous = new Set(selects.filter(select => !select.disabled && select.value).map(select => select.value));
    if (previous.size) {
      for (const input of this.querySelectorAll('[data-colour-choice]')) {
        input.checked = previous.has(input.value);
      }
    }
    for (const select of selects) select.disabled = true;
    basic.hidden = true;
    options.hidden = false;
    property.disabled = false;
    const count = this.querySelector('[data-colour-count]');
    if (count) count.hidden = false;
  }

  changeColour(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-colour-choice]')) return;
    if (input.checked && this.querySelectorAll('[data-colour-choice]:checked').length > 3) {
      input.checked = false;
    }
    this.syncColours();
  }

  /** Keep native FormData and disabled choices in step with the visible selection. */
  syncColours() {
    const inputs = [...this.querySelectorAll('[data-colour-choice]')];
    let selected = inputs.filter(input => input.checked);
    for (const input of selected.slice(3)) input.checked = false;
    selected = selected.slice(0, 3);
    for (const input of inputs) input.disabled = selected.length === 3 && !input.checked;
    const property = this.querySelector('[data-colour-property]');
    if (property instanceof HTMLInputElement) {
      property.value = selected.map(input => input.value).join(', ') || this.dataset.floristChoice || '';
    }
    const count = this.querySelector('[data-colour-count]');
    if (count) count.textContent = (this.dataset.countTemplate || '').replace('[count]', String(selected.length));
  }
}

if (!customElements.get('hoppipolla-colour-multi')) {
  customElements.define('hoppipolla-colour-multi', HoppipollaColourMulti);
}
